export const LANGUAGE_STORAGE_KEY = "vl-marketing-language-preference";
export const SUPPORTED_LANGUAGES = new Set(["en", "es"]);

export function normalizeLanguage(value) {
  const language = String(value || "")
    .trim()
    .toLowerCase()
    .replaceAll("_", "-")
    .split("-", 1)[0];
  return SUPPORTED_LANGUAGES.has(language) ? language : "";
}

export function getPreferredSupportedLanguage(languages) {
  const candidates = Array.isArray(languages)
    ? languages
    : languages
      ? [languages]
      : [];
  for (const candidate of candidates) {
    const language = normalizeLanguage(candidate);
    if (language) return language;
  }
  return "";
}

export function readStoredLanguage(storage) {
  try {
    return normalizeLanguage(storage?.getItem(LANGUAGE_STORAGE_KEY));
  } catch (error) {
    return "";
  }
}

export function writeStoredLanguage(storage, value) {
  const language = normalizeLanguage(value);
  if (!language) return "";
  try {
    storage?.setItem(LANGUAGE_STORAGE_KEY, language);
  } catch (error) {
    return language;
  }
  return language;
}

export function localizedUrl(alternateHref, currentLocation) {
  const destination = new URL(alternateHref, currentLocation.href);
  destination.search = currentLocation.search || "";
  destination.hash = currentLocation.hash || "";
  return destination.href;
}

export function shouldRedirectSavedSpanishHome({
  currentLocale,
  pathname,
  storedLanguage,
}) {
  return (
    normalizeLanguage(currentLocale) === "en" &&
    pathname === "/" &&
    normalizeLanguage(storedLanguage) === "es"
  );
}
